// Reading or opening an alert never stops its critical indication.
export const criticalAlertSx = (alert) =>
  alert?.severity === "error"
    ? {
        animation: "criticalAlertPulse 1.5s ease-in-out infinite",
        "@keyframes criticalAlertPulse": {
          "0%, 100%": { backgroundColor: "#fff1f0", boxShadow: "inset 4px 0 #b42318" },
          "50%": { backgroundColor: "#ffd1cd", boxShadow: "inset 4px 0 #e32619" },
        },
      }
    : {};
